import { render } from "./TableColumn.vue?vue&type=template&id=7b210520&scoped=true"
import script from "./TableColumn.vue?vue&type=script&lang=js"
export * from "./TableColumn.vue?vue&type=script&lang=js"

import "./TableColumn.vue?vue&type=style&index=0&id=7b210520&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b210520"]])

export default __exports__